export interface Step1Data {
  nomeCompleto: string;
  nomeSocial: string;
  cpf: string;
  genero: string;
  etnia: string;
  dataNascimento: string;
  paisNascimento: string;
  ufNascimento: string;
  municipioNascimento: string;
  rg: string;
  orgaoEmissor: string;
  ufOrgaoEmissor: string;
  email: string;
  telefoneCelular: string;
  enderecoResidencial: string;
  cep: string;
  bairro: string;
  pais: string;
  municipio: string;
  uf: string;
  vinculoEspecifico: string;
}

export const validateStep1 = (data: Step1Data): Partial<Step1Data> => {
  const errors: Partial<Step1Data> = {};

  if (!data.nomeCompleto.trim())
    errors.nomeCompleto = "Nome completo é obrigatório";
  if (!data.cpf.trim()) errors.cpf = "CPF é obrigatório";
  if (!data.genero) errors.genero = "Gênero é obrigatório";
  if (!data.etnia) errors.etnia = "Etnia é obrigatória";
  if (!data.dataNascimento)
    errors.dataNascimento = "Data de nascimento é obrigatória";
  if (!data.paisNascimento.trim())
    errors.paisNascimento = "País é obrigatório";
  if (!data.ufNascimento) errors.ufNascimento = "UF é obrigatória";
  if (!data.municipioNascimento.trim())
    errors.municipioNascimento = "Município é obrigatório";
  if (!data.rg.trim()) errors.rg = "RG é obrigatório";
  if (!data.orgaoEmissor.trim())
    errors.orgaoEmissor = "Órgão emissor é obrigatório";
  if (!data.ufOrgaoEmissor)
    errors.ufOrgaoEmissor = "UF do órgão emissor é obrigatória";
  if (!data.email.trim()) errors.email = "E-mail é obrigatório";
  if (!data.telefoneCelular.trim())
    errors.telefoneCelular = "Telefone é obrigatório";
  if (!data.enderecoResidencial.trim())
    errors.enderecoResidencial = "Endereço é obrigatório";
  if (!data.cep.trim()) errors.cep = "CEP é obrigatório";
  if (!data.bairro.trim()) errors.bairro = "Bairro é obrigatório";
  if (!data.pais.trim()) errors.pais = "País é obrigatório";
  if (!data.municipio.trim())
    errors.municipio = "Município é obrigatório";
  if (!data.uf) errors.uf = "UF é obrigatória";
  if (!data.vinculoEspecifico.trim())
    errors.vinculoEspecifico = "Vínculo específico é obrigatório";

  return errors;
};
